module.exports = __webpack_public_path__ + "static/grundriss_gewerbe-a53468504450414b20b0327dc1117d7b.png";